module.exports = __webpack_public_path__ + "img/dragster.92f0e130.gif";